import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'confirmation-window',
  templateUrl: './confirmation-window-control.component.html',
  styleUrls: ['./confirmation-window-control.component.scss']
})
export class ConfirmationWindowControlComponent implements OnInit {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() iconClasses: string = '';
  @Input() icon: string = '';
  @Input() hideOnConfirm: boolean = true;

  @Output() onConfirm = new EventEmitter<boolean>();
  
  @ViewChild('confirmationModal') public confirmationModal: ModalDirective;
  
  constructor() { }

  ngOnInit() {
  }

  @Input() set show(show: boolean) {
    if (this.confirmationModal) {
      if (show) this.confirmationModal.show();
      else this.hideModal();
    }
  }

  _hide() {
    this.onConfirm.emit(false);
    if (this.hideOnConfirm) this.hideModal();
  }

  confirm() {
    this.onConfirm.emit(true);
    if (this.hideOnConfirm) this.hideModal();
  }

  hideModal() {
    this.confirmationModal.hide();
  }
}
